import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';
export const getUserEmail = createSelector(getUser, get('email'));